import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getNextBestActions, putNextBestActionFeedback } from '../services/NextBestActionService';

export const useNextBestActionGetNextBestActions = createDCHook(
  'getNextBestActions',
  collapseDataFromCall(getNextBestActions),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useNextBestActionPutNextBestActionFeedback = createMutationHook(
  collapseParams(
    collapseParams(putNextBestActionFeedback, 'requestBody', 'data'),
    'data',
    'actionId',
    'contextId',
    'servingPointId',
    'treatmentVariationId',
    'status',
    'channel',
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: ['actionId', 'contextId', 'servingPointId', 'treatmentVariationId', 'status', 'channel'],
      },
    ],
  },
);
